import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './shared/Navbar';
import Footer from './shared/Footer';

export default function Page404() {
  return (
    <div className="App" style={{display:'flex', flexDirection:'column', minHeight:'100vh'}}>
      <Navbar />
      <div style={{flex:1, display:'flex', alignItems:'center', justifyContent:'center', padding:'80px 24px 60px'}}>
        <div style={{textAlign:'center', maxWidth:600}}>

          {/* Illustration SVG — pirogue perdue avec points d'interrogation */}
          <svg viewBox="0 0 500 300" xmlns="http://www.w3.org/2000/svg" style={{width:'100%', maxWidth:520, marginBottom:32, display:'block', marginLeft:'auto', marginRight:'auto'}}>
            <defs>
              <linearGradient id="sky" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#87CEEB"/>
                <stop offset="100%" stopColor="#E0F4FF"/>
              </linearGradient>
              <linearGradient id="sea" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#1565C0"/>
                <stop offset="100%" stopColor="#0D47A1"/>
              </linearGradient>
            </defs>

            {/* Ciel */}
            <rect width="500" height="220" fill="url(#sky)"/>
            {/* Soleil */}
            <circle cx="420" cy="58" r="38" fill="#F2BF5E" opacity="0.9"/>
            {[0,45,90,135,180,225,270,315].map(a => (
              <line key={a}
                x1={420 + Math.cos(a*Math.PI/180)*43}
                y1={58  + Math.sin(a*Math.PI/180)*43}
                x2={420 + Math.cos(a*Math.PI/180)*56}
                y2={58  + Math.sin(a*Math.PI/180)*56}
                stroke="#F2BF5E" strokeWidth="3" opacity="0.7"/>
            ))}
            {/* Nuages */}
            <ellipse cx="90"  cy="55" rx="45" ry="18" fill="white" opacity="0.8"/>
            <ellipse cx="130" cy="48" rx="35" ry="16" fill="white" opacity="0.8"/>
            <ellipse cx="62"  cy="50" rx="30" ry="14" fill="white" opacity="0.8"/>
            <ellipse cx="255" cy="78" rx="38" ry="15" fill="white" opacity="0.55"/>
            <ellipse cx="290" cy="72" rx="28" ry="13" fill="white" opacity="0.55"/>

            {/* Mer */}
            <rect y="210" width="500" height="90" fill="url(#sea)"/>
            <path d="M0 220 Q30 210 60 220 Q90 230 120 220 Q150 210 180 220 Q210 230 240 220 Q270 210 300 220 Q330 230 360 220 Q390 210 420 220 Q450 230 480 220 L500 220 L500 230 L0 230Z" fill="white" opacity="0.15"/>
            <path d="M0 242 Q25 235 50 242 Q75 249 100 242 Q125 235 150 242 Q175 249 200 242 Q225 235 250 242 Q275 249 300 242 Q325 235 350 242 Q375 249 400 242 Q425 235 450 242 Q475 249 500 242 L500 252 L0 252Z" fill="white" opacity="0.1"/>

            {/* Pirogue */}
            <path d="M130 196 Q180 181 250 183 Q320 185 360 196 Q340 211 250 213 Q160 211 130 196Z" fill="#8B4513"/>
            <path d="M130 196 Q180 183 250 185 Q320 187 360 196" stroke="#5D2E0C" strokeWidth="2" fill="none"/>
            {/* Mât */}
            <line x1="245" y1="118" x2="245" y2="185" stroke="#5D2E0C" strokeWidth="4"/>
            {/* Voile — couleur unie bordeaux Welly */}
            <path d="M245 123 L318 156 L245 183Z" fill="#973265" opacity="0.85"/>
            <path d="M245 123 L245 183 L172 156Z" fill="#F2BF5E" opacity="0.85"/>
            {/* Personnage */}
            <circle cx="200" cy="186" r="10" fill="#8B6914"/>
            <rect x="194" y="193" width="12" height="14" rx="3" fill="#5D2E0C"/>

            {/* Points d'interrogation — grands, dispersés autour de la pirogue */}
            {/* Grand central */}
            <circle cx="375" cy="148" r="26" fill="white" opacity="0.97"/>
            <text x="375" y="158" textAnchor="middle" fontSize="30" fontWeight="900" fill="#973265">?</text>

            {/* Haut gauche */}
            <circle cx="80" cy="140" r="20" fill="white" opacity="0.92"/>
            <text x="80" y="148" textAnchor="middle" fontSize="22" fontWeight="900" fill="#F2BF5E">?</text>

            {/* Milieu gauche — petit */}
            <circle cx="148" cy="110" r="14" fill="white" opacity="0.85"/>
            <text x="148" y="116" textAnchor="middle" fontSize="16" fontWeight="900" fill="#973265">?</text>

            {/* Haut droite — moyen */}
            <circle cx="330" cy="100" r="17" fill="white" opacity="0.88"/>
            <text x="330" y="107" textAnchor="middle" fontSize="19" fontWeight="900" fill="#F2BF5E">?</text>

            {/* Bas droite */}
            <circle cx="420" cy="185" r="15" fill="white" opacity="0.9"/>
            <text x="420" y="192" textAnchor="middle" fontSize="17" fontWeight="900" fill="#973265">?</text>

            {/* Tout petit — coin haut */}
            <circle cx="200" cy="95" r="10" fill="white" opacity="0.8"/>
            <text x="200" y="101" textAnchor="middle" fontSize="12" fontWeight="900" fill="#F2BF5E">?</text>
          </svg>

          <div style={{
            display:'inline-block',
            background:'#fdf2f8',
            padding:'6px 18px',
            borderRadius:50,
            fontSize:13,
            fontWeight:700,
            color:'#973265',
            marginBottom:16,
            letterSpacing:'0.05em',
          }}>
            Erreur 404
          </div>

          <h1 style={{fontSize:32, fontWeight:800, color:'#1a1a1a', marginBottom:12, lineHeight:1.3}}>
            Cette pirogue s'est perdue en mer 🌊
          </h1>

          <p style={{fontSize:16, color:'#666', lineHeight:1.7, marginBottom:8}}>
            La page que tu cherches n'existe pas (ou a peut-être été emportée par les vagues).
          </p>
          <p style={{fontSize:15, color:'#888', marginBottom:36}}>
            Pas de panique — l'équipe Welly est là pour te ramener à bon port.
          </p>

          <div style={{display:'flex', justifyContent:'center'}}>
            <Link to="/" style={{
              display:'inline-flex', alignItems:'center', gap:10,
              padding:'13px 28px', background:'#973265',
              borderRadius:50, color:'white', fontWeight:600,
              fontSize:15, textDecoration:'none',
            }}>
              ← Retour à l'accueil
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
